import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { fetchOtpAppSms, updateOtpStatus, addUpdateOtpApp, sendOtp } from '../../store/actions/otpAppAction'
import { fetchApp } from '../../store/actions/appAction'

import { makeStyles } from '@material-ui/core/styles';
// import env from "../../env"
// import { Typography, Grid, Switch, TextField, Button, Divider, Accordion, AccordionSummary, AccordionDetails, Box,Tabs, Tab, AppBar, Avatar } from '@material-ui/core';
import { Typography, Grid, Switch, TextField, Button } from '@material-ui/core';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    
}));

const Sms = () => {
    const dispatch = useDispatch()
    const classes = useStyles();
    const {id} = useParams()
    const category = 'smsOTP'
    const message = `Kode OTP Anda xxx-xxx. Gunakan OTP untuk masuk ke aplikasi. Jaga kerahasiaan kode termasuk ke petugas kami`

    const [active, setActive] = useState(false);
    const [ input, setInput ] = useState({
      brand: '',
      phone: ''
    })

    useEffect(() => {
      dispatch(fetchApp(id))
    }, [dispatch, id])

    const app = useSelector(state => state.appReducer.app)

    useEffect(() => {
      dispatch(fetchOtpAppSms(id, category))
      return () => {
          const cleanupInput = {
              brand: '',
              phone: ''
          }
        setInput(JSON.parse(JSON.stringify(cleanupInput)))
      }  
    }, [dispatch, id, category])
    
    const otpApp = useSelector(state => state.otpAppReducer.otpAppSms)
    const customerOtpApp = useSelector(state => state.otpAppReducer.customer)

    useEffect(() => {
      if (otpApp) {
          const newInput = {
              brand: otpApp.brand,
              phone: ''
          }
          setActive(otpApp.status === 'active')
          setInput(JSON.parse(JSON.stringify(newInput)))              
      }
    }, [otpApp])

    const handleSubmit = (e) => {
      e.preventDefault()
      input.appId = id
      input.category = category
      dispatch(addUpdateOtpApp(input))
    }

    const handleFormChange = (e) => {
      let { name, value } = e.target
      setInput({ ...input, [name]: value })  
    }

    const handleSwitchChange = (e) => {
      setActive(e.target.checked);
      const payload = {appId:id, category, status: e.target.checked }
      dispatch(updateOtpStatus(payload))
    }

    const smsOtpLogin = () => {
      const payload = {apiKey:app.apiKey, phone:input.phone, provider: category }
      dispatch(sendOtp(payload))
    }

    return (
        <div>
        <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom>
          SMS OTP
        </Typography>
          <br/>
          <Grid item xs={12} md={12} className={classes.contentOtpLogin}>
          <div>
              <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                  className="mb-15">
                  <Grid item>
                      <Typography className="d-flex reguler" style={{flexDirection: "row", justifyContent: "center"}}>
                        SMS OTP Form
                      </Typography>        
                  </Grid>
                  <Grid item>
                      <span className="mb-0 reguler text-grey font-size-14">
                          Status: 
                          <span>Enable</span>
                      </span>
                      <Switch
                          checked={active}
                          onChange={handleSwitchChange}
                          color="primary"
                          name="checked"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                      />        
                  </Grid>
              </Grid>
              {
                  active && 
                  <div>
                      <form onSubmit={handleSubmit}>
                          <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                              <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Sender ID</p>
                              <TextField
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              id="senderID"
                              name="senderID"
                              value={"QKEY"}
                              autoFocus
                              onChange={handleFormChange}
                              style={{marginBottom: "1.5rem"}}
                              />
                              {/* <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama Brand</p>
                              <TextField
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              id="brand"
                              name="brand"
                              value={input.brand}
                              autoFocus
                              onChange={handleFormChange}
                              /> */}
                            </Grid>
                            <Grid item xs={12} md={6}> 
                              <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Masukkan Nomor (+62)</p>
                              <TextField
                              variant="outlined"
                              margin="dense"
                              fullWidth
                              name="phone"
                              id="phone"
                              value={input.phone}
                              autoFocus
                              onChange={handleFormChange}
                              style={{marginBottom: "1.5rem"}}
                              />
                              <br/>
                              <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "5px"}}>Contoh Pesan</p>
                              <TextField
                                id="message outlined-multiline-static"
                                variant="outlined"
                                margin="none"
                                size="small"
                                placeholder="Deskripsi Website / Apps Anda"
                                defaultValue=""
                                required
                                fullWidth
                                multiline
                                rows={4}
                                name="message"
                                value={message}
                              />
                            </Grid>
                          </Grid>
                          
                          <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                            <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => smsOtpLogin()}
                            className="btn-white text-transform-unset"
                            style={{padding: "5px 40px", marginRight: "20px"}}
                            >
                            Send Message
                            </Button>

                            <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="btn-black text-transform-unset"
                            style={{padding: "5px 40px"}}
                            >
                            Save
                            </Button>
                          </div>
                  </form>
                  </div>
              }
          </div>
          </Grid>
          <br/>
        </div>
    )
}

export default Sms
